<button class="button-component" (click)="onClick($event)">
  <div class="button-component__content">
    {{ content }}
  </div>
  <div class="button-component__arrow-container">
    <arrow-icon></arrow-icon>
  </div>
</button>
